import React from 'react';
import { View,Text } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

const receber =()=>{
    return(
        <View style={{backgroundColor:'dodgerblue',height:'100%',width:'100%'}}>
     
        <View style={{margin:10,flexDirection:'row'}}> 
        <Ionicons name="ios-checkmark-circle" size={30} color="white" />
        <Text style={{color:'white'}}>Se a transação foi aprovada com sucesso o dinheiro é transferido para a conta cadastrada em menos de uma hora em média</Text>  
        </View>

        <View style={{margin:10,flexDirection:'row'}}> 
        <Ionicons name="ios-checkmark-circle" size={30} color="white" />
        <Text style={{color:'white'}}>Todo processo é automatico você não precisar fazer nada além de solicitar seu valor no botão trocar e aguardar. O tempo mêdio é de uma hora</Text>  
        </View>
        
        </View>
    );

}
export default receber;